module.exports = __webpack_public_path__ + "static/img/Clogo.65bccf47.png";